import $ from 'jquery';
import { emitter } from './emitter';
/**
 *
 * @module disclaimer-modal
 * @version 0.1.0
 * @author hello@bradenericson.com
 *
 * Generated on 2017-10-11 using @14four/generator-excalibur 0.1.23
 * Converted to ES6 on 2023-12-01 using ChatGPT
 */

class DisclaimerModal {
  constructor(element) {
    this.$el = $(element);
    this.setupBinds();
    // Log removed: 'DisclaimerModal : Initialized'
  }

  setupBinds() {
    emitter.on('showDisclaimer', this.onShowDisclaimer.bind(this));
    this.$el.find('.accept-button').on('click',this.onContinueClick.bind(this));
    this.$el.find('.close-x').on('click',this.onCloseClick.bind(this));
  }

  onShowDisclaimer(data) {
    this.link = data.link;
    this.$el.addClass('open');
    $('body').addClass('modal-open');
  }

  onContinueClick() {
    window.open(this.link, '_blank');
    this.onCloseClick();
  }

  onCloseClick() {
    $('body').removeClass('modal-open');
    this.$el.removeClass('open');
  }
}

export default DisclaimerModal;
